import { IDetailsColumnStyles, IDetailsColumnStyleProps } from '@fluentui/react';

export const DetailsColumnStyles = (props: IDetailsColumnStyleProps): Partial<IDetailsColumnStyles> => {
  const { theme } = props;
  return {
    cellName: {
      fontSize: theme.fonts.small.fontSize,
    },
  };
};
